if (window.location.hash === '#subscribe') {
  var attempts = 0;
  var interval = setInterval(function() {
    var klaviyo = document.querySelector('.klaviyo-form-VdHbkc');
    if (klaviyo && klaviyo.offsetHeight > 0) {
      window.scrollTo({ top: klaviyo.getBoundingClientRect().top + window.scrollY - 60, behavior: 'smooth' });
      clearInterval(interval);
    }
    if (++attempts > 50) clearInterval(interval);
  }, 300);
}
